// extracted by mini-css-extract-plugin
module.exports = {"container":"_2iHVWkq4BANz","list":"_2rzgXTTCkxwM","item":"_1VpGYty__EJ2","item_gone":"BrfObB7SgnnF"};